import React from 'react';
import { twMerge } from 'tailwind-merge';
type Tone = 'light' | 'dark' | 'plain';
interface CardProps {
  tone?: Tone;
  className?: string;
  children: React.ReactNode;
  as?: 'div' | 'section' | 'article';
}
const tones: Record<Tone, string> = {
  light: 'bg-white/70 border border-sand-line text-deep',
  dark: 'bg-deep text-sand border border-white/5',
  plain: 'bg-transparent'
};
export function Card({
  tone = 'light',
  className,
  children,
  as = 'div'
}: CardProps) {
  const Tag = as;
  return <Tag className={twMerge('rounded-card', tones[tone], className)} data-id="element-1491" data-mp="m2jwisebp4i4">
      {children}
    </Tag>;
}
export function SectionTitle({
  children,
  action
}: {
  children: React.ReactNode;
  action?: React.ReactNode;
}) {
  return <div className="mb-2 flex items-end justify-between gap-2" data-id="element-1492" data-mp="w0rdhb8m3mk4">
      <h2 className="text-section text-deep" data-id="element-1493" data-mp="2sukoxt5b9b3n">{children}</h2>
      {action}
    </div>;
}